import * as yup from 'yup';

const qtnSchema = yup
  .string()
  .typeError('schemas.qtn.string')
  .required('schemas.qtn.required')
  .test('len', 'schemas.qtn.exact', val => !val || (val && val.toString().length === 6));

export default qtnSchema;
